export const faces = [
	"😀",
	"😁",
	"😂",
	"🤣",
	"😊",
	"😎",
	"😍",
	"😘",
	"😏",
	"😒",
	"😔",
	"😕",
	"😢",
	"😭",
	"🤔",
	"😬",
	"😷",
	"🤢",
	"😴",
	"🥳",
];

export const hands = [
	"👍",
	"👎",
	"👋",
	"✌️",
	"🤞",
	"🤟",
	"👏",
	"🙌",
	"🤲",
	"🙏",
	"🤝",
	"💪",
	"✋",
	"👌",
	"🤙",
	"👊",
	"🤜",
	"🤛",
	"👆",
	"👇",
];

export const miscellaneous = [
	"💻",
	"🖨️",
	"📱",
	"📞",
	"📅",
	"📝",
	"📈",
	"📉",
	"📁",
	"📦",
	"📨",
	"🚗",
	"🚙",
	"🛻",
	"🛠️",
	"🪛",
	"⛽",
	"💵",
	"💳",
	"💲",
];
